import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";

const emptyState = tv({
  slots: {
    wrapper: "@container",
    root: [
      "flex flex-col items-center justify-center gap-6 rounded-3xl bg-neutral-25 p-10 text-center",
      "@2xl:flex-row @2xl:text-left",
    ],
    illustration: "shrink-0 mix-blend-multiply [&>img]:mix-blend-multiply [&>svg]:mix-blend-multiply",
    content: "flex max-w-[240px] flex-col",
    title: "text-xl/7 font-bold text-neutral-600",
    description: "text-sm/5 text-neutral-400",
    actions: "mt-4 flex justify-center @2xl:justify-start",
  },
});

export interface EmptyStateProps {
  /** Optional CTA rendered inside the card, below the description. */
  action?: ReactNode;
  className?: string;
  description: string;
  illustration: ReactNode;
  title: string;
}

export function EmptyState({ action, className, description, illustration, title }: EmptyStateProps) {
  const styles = emptyState();

  return (
    <div className={styles.wrapper({ className })}>
      <div className={styles.root()}>
        <div aria-hidden="true" className={styles.illustration()}>
          {illustration}
        </div>
        <div className={styles.content()}>
          <p className={styles.title()}>{title}</p>
          <p className={styles.description()}>{description}</p>
          {action ? <div className={styles.actions()}>{action}</div> : null}
        </div>
      </div>
    </div>
  );
}
